export enum UtilizationSurveyQuestions {
  PhysicianVisits = 3,
  SpecialistVisits = 4,
  HospitalAdmissions = 5
}

export type UtilizationContentKey = keyof typeof defaultUtilizationContent
export const defaultUtilizationContent = {
  utilization_form_select_placeholder: 'Please select',
  no_phys_visits: '0 times',
  no_phys_visits_radio: '0',
  one_to_three_phys_visits: '1 to 3 times',
  one_to_three_phys_visits_radio: '1-3',
  four_plus_phys_visits: '4 or more times',
  four_plus_phys_visits_radio: '4+',
  no_spec_visits: '0 times',
  no_spec_visits_radio: '0',
  one_to_four_spec_visits: '1 to 4 times',
  one_to_four_spec_visits_radio: '1-4',
  five_to_nine_spec_visits: '5 to 9 times',
  five_to_nine_spec_visits_radio: '5-9',
  ten_plus_spec_visits: '10 or more times',
  ten_plus_spec_visits_radio: '10+',
  no_hosp_visits: '0 times',
  no_hosp_visits_radio: '0',
  one_hosp_visit: '1 time',
  one_hosp_visit_radio: '1',
  two_plus_hosp_visits: '2 or more times',
  two_plus_hosp_visits_radio: '2+',
  primary_care_label: 'seen your primary care physician?',
  specialist_label: 'seen a specialist?',
  hospital_label: 'been admitted to the hospital?'
}

export type UtilizationAmount = (typeof utilizationAmounts)[number]
export const utilizationAmounts = [
  '0',
  '1_3',
  'gte_4',
  '1_4',
  '5_9',
  'gte_10',
  '1',
  'gte_2'
] as const

export class HealthcareUtilization {
  static use(content?: Record<UtilizationContentKey, string>) {
    // TODO: Consider creating CMS component specific to this and getting it here if passed in content is null
    if (!content) content = defaultUtilizationContent

    const utilizationSelectPlaceholder = computed(
      () => content?.utilization_form_select_placeholder
    )
    const priCareLabel = computed(() => content?.primary_care_label)
    const specLabel = computed(() => content?.specialist_label)
    const hospLabel = computed(() => content?.hospital_label)

    const physicianVisitsOpts = computed(() => [
      {
        text: content?.no_phys_visits_radio,
        value: '0'
      },
      {
        text: content?.one_to_three_phys_visits_radio,
        value: '1_3'
      },
      {
        text: content?.four_plus_phys_visits_radio,
        value: 'gte_4'
      }
    ])

    const specialistVisitsOpts = computed(() => [
      {
        text: content?.no_spec_visits_radio,
        value: '0'
      },
      {
        text: content?.one_to_four_spec_visits_radio,
        value: '1_4'
      },
      {
        text: content?.five_to_nine_spec_visits_radio,
        value: '5_9'
      },
      {
        text: content?.ten_plus_spec_visits_radio,
        value: 'gte_10'
      }
    ])

    const hospitalVisitsOpts = computed(() => [
      {
        text: content?.no_hosp_visits_radio,
        value: '0'
      },
      {
        text: content?.one_hosp_visit_radio,
        value: '1'
      },
      {
        text: content?.two_plus_hosp_visits_radio,
        value: 'gte_2'
      }
    ])

    return {
      utilizationSelectPlaceholder,
      priCareLabel,
      specLabel,
      hospLabel,
      physicianVisitsOpts,
      specialistVisitsOpts,
      hospitalVisitsOpts
    }
  }
}
